<oe-flat-widget [title]="'GENERAL.CUR_YEAR_EMISSIONS' | translate" [icon]="{name: 'oe-consumption', color: 'environmental'}" class="signage-font-nowrap">
    <ng-container>
      <p class="signage-font-edge5card">{{getYearReduction()}}</p>
    </ng-container>
</oe-flat-widget>
